import React from 'react';

const EtaGradiant = () => {
    return (
        <div className="row">
            <div className="col">
                <table className="gradiantTableWidth mb-2">
                    <thead className="text-center">
                        <tr className="myGradiant-text">
                            <th>Planned</th>
                            <th>Started</th>
                            <th>Dispatched</th>
                            <th>Delivered</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="myGradiant">
                            <td colSpan={4}>
                                &nbsp;
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default EtaGradiant;